<template>
  <div :class="daisy_ui_styling ? 'flex justify-center' : 'row'">
    <div :class="classes" id="element-for-full-screen">
      <table :class="daisy_ui_styling ? 'm-auto' : 'm-a'">
        <tbody>
        <tr>
          <td>
            <div class="relative">
              <img :src="settings.background_image_url" alt="" class="img-fluid">
              <slide :current_time="current_time" :slides="slides" :settings="settings"></slide>
              <iframe :src="video_src" :id="player_id" :style="settings.video_style" frameborder="0" allowfullscreen v-if="is_video"></iframe>
            </div>
          </td>
        </tr>
        <tr v-if="include_video_action_bar">
          <td>
            <time-indicator :media_duration="video_duration" :current_time="current_time" :progress_percentage="progress_percentage"
                            :daisy_ui_styling="daisy_ui_styling"
                            :show_play_actions="true" :show_full_screen_options="true"
                            :is_playing="is_playing" :is_full_screen="is_full_screen"
                            @on_play_toggle="on_play_toggle()" @on_full_screen_toggle="on_full_screen_toggle()"
                            @set_current_time="set_current_time($event)"></time-indicator>
          </td>
        </tr>
        <tr v-if="include_audio_action_bar">
          <td class="py-4">
            <audio style="width: 100%" ref="audio_player" controls controlsList="nodownload">
              <source :src="audio_file_url" type="audio/mpeg">
              Your browser does not support the audio tag.
            </audio>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import TimeIndicator from './time_indicator.vue'
  import Slide from './slide.vue'
  import Player from '@vimeo/player';

  import fscreen from 'fscreen';

  export default {
    components: { TimeIndicator, Slide },
    props: {
      daisy_ui_styling: {
        type: Boolean,
        required: false,
        default: false
      },
      video_id: {
        type: String,
        required: false,
        default: "261635732"
      },
      audio_file_url: {
        type: String | Boolean,
        required: false
      },
      settings: {
        type: Object,
        required: true
      },
      slides: {
        type: Array,
        required: true
      },
      init_player: {
        type: Boolean,
        required: true
      },
      media_type: {
        type: String,
        required: true
      }
    },
    data: function(){
      return {
        is_playing: false,
        is_full_screen: false,
        has_ended: false,
        vimeo_player: null,
        player_id: `vimeo-iframe-${parseInt(Math.random() * 10000000)}`,
        video_duration: 0,
        current_time: 0,
        progress_percentage: 0,
        classes: this.daisy_ui_styling ? 'w-full md:w-2/3' : 'col-md-8 offset-md-2',
      }
    },
    created: function(){
      fscreen.addEventListener('fullscreenchange', this.full_screen_listener, false);
    },
    destroyed: function(){
      fscreen.removeEventListener('fullscreenchange', this.full_screen_listener, false);
    },
    mounted: function(){
      if (this.init_player){
        if (this.is_video) {
          this.do_init_video_player()
        } else if (this.is_audio) {
          this.do_init_audio_player()
        }
      }
    },
    computed: {
      is_video: function(){
        return this.media_type === 'video'
      },
      is_audio: function(){
        return this.media_type === 'audio'
      },
      video_src: function(){
        return `//player.vimeo.com/video/${this.video_id}`
      },
      include_video_action_bar: function(){
        return this.is_video && this.settings.include_action_bar && this.vimeo_player
      },
      include_audio_action_bar: function(){
        return this.is_audio && this.settings.include_action_bar
      }
    },
    methods: {
      full_screen_listener: function(){
        if (fscreen.fullscreenElement !== null) {
          this.classes = '';
          this.is_full_screen = true;
        } else {
          this.classes = this.daisy_ui_styling ? 'w-full md:w-2/3' : 'col-md-8 offset-md-2'
          this.is_full_screen = false;
        }
      },
      on_play_toggle: function(){
        if (this.has_ended){
          // replay the video
          this.set_current_time(0);
          this.has_ended = false
        }

        const callback = this.is_playing ? this.vimeo_player.pause() : this.vimeo_player.play();
        const new_value = !this.is_playing;

        callback.then(() => {
          this.is_playing = new_value
        })
      },
      set_current_time: function(time){
        this.vimeo_player.setCurrentTime(time);
      },
      on_full_screen_toggle: function(){
        if (this.is_full_screen){
          fscreen.exitFullscreen()
        }else{
          const element = document.getElementById('element-for-full-screen')
          fscreen.requestFullscreen(element)
        }
      },
      do_init_audio_player: function(){
        const audio_player = this.$refs.audio_player;

        audio_player.ontimeupdate = () => {
          this.current_time = audio_player.currentTime;
        }
      },
      do_init_video_player: function(){
        this.vimeo_player = new Player(this.player_id);

        this.vimeo_player.getDuration().then((duration) => {
          this.video_duration = duration
        });

        this.vimeo_player.on('timeupdate', (data) => {
          this.current_time = data.seconds;
          this.progress_percentage = data.percent * 100
        });

        this.vimeo_player.on('play', () => {
          this.is_playing = true;
          this.has_ended = false
        });

        this.vimeo_player.on('pause', () => {
          this.is_playing = false
        });

        this.vimeo_player.on('ended', () => {
          this.is_playing = false;
          this.has_ended = true
        })
      }
    }
  }
</script>